import { render, staticRenderFns } from "./ConfigComponent.vue?vue&type=template&id=2c30340e"
import script from "./ConfigComponent.vue?vue&type=script&lang=js"
export * from "./ConfigComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports